<template>
  <a-select :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners"
  v-if="editMode">
    <a-icon slot="suffixIcon" type="caret-down" v-if="showArrow"/>
    <span slot="suffixIcon" v-else></span>
    <a-select-option v-for="u in units" :key="u.id" :value="u.id">{{u.shortName}}</a-select-option>
  </a-select>
<!--  <span v-else>{{units.find(e=>{return e.id == this.value}).shortName}}</span>-->
  <span v-else>{{filterUnit(units)}}</span>
</template>

<script>
  import unitApi from '@/api/manager/unit'
  export default {
    name: 'ptUnitSelect',
    props:{
      showArrow:{
        type:Boolean,
        default:true,
      },
      editMode:{
        type:Boolean,
        default:true,
      },
      allowClear:{
        type:Boolean,
        default:false,
      },
      value:{
        type: [Object, Array],
      },
      type:{
        type:String,
        default:'rent'
      }
    },
    mounted(){
      this.init();
    },
    data() {
      return {
        input:this.value,
        units:[]
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
      input(val){
        this.$emit('input',val)
      }
    },
    methods:{
      filterUnit(units){
        if(units.length > 0){
          let curUnit = units.find(e=>{return e.id == this.value});
          if(curUnit){
            return curUnit.shortName;
          }
          return curUnit;
        }else{
          return null;
        }
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('changeValue',value);
      },
      init(){
        if(this.type == 'area'){
          this.initAreaUnit();
        }else if(this.type == 'rent'){
          this.initRentUnit();
        }else if(this.type == 'currency'){
          this.initCurrencyUnit();
        }else if(this.type == 'cycle'){

        }
      },
      initAreaUnit(){
        unitApi.selectByType(unitApi.unitTypeEnum.AREA).then(res=>{
          if(res.code == 1){
            this.units = res.data
          }
        })
      },
      initRentUnit(){
        unitApi.selectByType(unitApi.unitTypeEnum.RENT).then(res=>{
          if(res.code == 1){
            this.units = res.data
          }
        })
      },
      initCurrencyUnit(){
        unitApi.selectByType(unitApi.unitTypeEnum.CURRENCY).then(res=>{
          if(res.code == 1){
            this.units = res.data
          }
        })
      },
    }
  }
</script>

<style scoped>
  .ant-select-disabled{
    color: rgba(0, 0, 0, 0.25) !important;
  }
</style>